module.exports = __webpack_public_path__ + "static/media/landing_photo.88ccf419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/landing_photo.png
// module id = 325
// module chunks = 0